import { memo } from 'react';

import { icons as atomicIcons, Icon } from '@stratumn/atomic';

import StratumnIcons from '@stratumn/icons/lib/DynamicIcon';
import { type LucideIcon, icons as lucideIcons } from 'lucide-react';

type Props = {
  icon: string;
  size: number;
};

export const DynamicIcon = memo(
  ({ icon = 'lucide_File', size = 35 }: Props) => {
    if (icon?.startsWith(LUCIDE_PREFIX)) {
      const iconName = icon.replace(LUCIDE_PREFIX, '');

      const LucideIconGenerated = lucideIcons[iconName] as
        | LucideIcon
        | undefined;
      if (LucideIconGenerated) {
        const iconSize = size * 0.9; // Lucide icons are bigger than stratumn ones.
        return <LucideIconGenerated size={iconSize} />;
      }
    }

    // Atomic icons
    if (atomicIcons[icon]) {
      return <Icon name={icon} size={size} />;
    }
    // @stratumn/icons
    return <StratumnIcons icon={icon} style={{ width: size, height: size }} />;
  }
);

const LUCIDE_PREFIX = 'lucide_' as const;
